import axios from 'axios'
import state from './state.js'

const baseURL = '/back-office'
const fastListURL = baseURL + '/list/fast'

export default class ApiManagerBoCutomer {
    /**
     * Fetch prestations.
     */
    static fetchPrestations() {
        return axios
            .get(`${fastListURL}/prestations`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching prestations:', error)
                throw error
            })
    }

    /**
     * Fetch prestation categories.
     */
    static fetchPrestationCategories() {
        return axios
            .get(`${fastListURL}/prestation-categories`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching prestation categories:', error)
                throw error
            })
    }

    /**
     * Fetch product categories.
     */
    static fetchProductCategories() {
        return axios
            .get(`${fastListURL}/product-categories`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching product categories:', error)
                throw error
            })
    }

    /**
     * Fetch products.
     */
    static fetchProducts() {
        return axios
            .get(`${fastListURL}/product`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching products:', error)
                throw error
            })
    }

    /**
     * Fetch origins.
     */
    static fetchOrigins() {
        return axios
            .get(`${fastListURL}/origin`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching origins:', error)
                throw error
            })
    }

    /**
     * Fetch brands.
     */
    static fetchBrands() {
        return axios
            .get(`${fastListURL}/brand`)
            .then((res) => res.data.data)
            .catch((error) => {
                console.error('Error fetching brands:', error)
                throw error
            })
    }

    /**
     * Fetch all list for customer filters.
     */
    static async fetchAllListsForCustomerFilters() {
        try {
            const [prestationCategories, productCategories, prestations, products, origins, brands] = await Promise.all([
                this.fetchPrestationCategories(),
                this.fetchProductCategories(),
                this.fetchPrestations(),
                this.fetchProducts(),
                this.fetchOrigins(),
                this.fetchBrands(),
            ])

            return {
                prestationCategories,
                productCategories,
                prestations,
                products,
                origins,
                brands,
            }
        } catch (error) {
            console.error('Error fetching all data for filters:', error)
            throw error
        }
    }

    /**
     * Fetch customers.
     */
    static fetchCustomers(params) {
        return axios
            .get(`${baseURL}/customers-v2/ajax`, { params })
            .then((res) => {
                state.customers = res.data.data
                return state.customers
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }

    /**
     * download customers.
     */
    static downloadCustomers(params) {
        return axios
            .get(`${baseURL}/customers-v2/export`, {
                responseType: 'blob',
                params,
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                const timestamp = new Date().getTime()
                link.href = url
                link.setAttribute('download', `customers-list-${timestamp}.xlsx`)
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
            })
            .catch((error) => {
                console.error('Error downloading Excel file:', error)
                throw error
            })
    }

    static async fetchApplyFilters(params) {
        state.filtersChanged = false
        return axios
            .get(`${baseURL}/customers-v2/filters/applied`, { params })
            .then((res) => {
                state.filtersChanged = true
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching ApplyFilters:', error)
                throw error
            })
    }

    static async applyFilters(payload) {
        state.filtersChanged = false
        return axios
            .post(`${baseURL}/customers-v2/filters/apply`, payload)
            .then((res) => {
                state.filtersChanged = true
                return res.data
            })
            .catch((error) => {
                console.error('Error post ApplyFilters:', error)
                throw error
            })
    }

    static async sendEmails(payload) {
        state.filtersChanged = false
        return axios
            .post(`${baseURL}/customers-v2/send-emails`, payload)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error sendEmails:', error)
                throw error
            })
    }

    static async saveEmailDesign(payload) {
        return axios
            .post(`${baseURL}/customers-v2/save-email-design`, payload)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error saveEmailDesign:', error)
                throw error
            })
    }

    static async fetchSavedEmailsTemplates() {
        return axios
            .get(`${baseURL}/customers-v2/emails-templates`)
            .then((res) => {
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching email list', error)
                throw error
            })
    }

    static async fetchListEmails(params) {
        state.filtersChanged = false
        return axios
            .get(`${baseURL}/customers-v2/list/emails`, { params })
            .then((res) => {
                state.filtersChanged = true
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching email list', error)
                throw error
            })
    }

    static async fetchSendedEmailCustomersList(params) {
        return axios
            .get(`${baseURL}/customers-v2/list/emails/customers`, { params })
            .then((res) => {
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching email customer list', error)
                throw error
            })
    }

    static async sendSms(payload) {
        state.filtersChanged = false
        return axios
            .post(`${baseURL}/customers-v2/send-sms`, payload)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error sendSms:', error)
                throw error
            })
    }

    static async fetchListSms(params) {
        state.filtersChanged = false
        return axios
            .get(`${baseURL}/customers-v2/list/sms`, { params })
            .then((res) => {
                state.filtersChanged = true
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching email list', error)
                throw error
            })
    }

    static async fetchSendedSmsCustomersList(params) {
        return axios
            .get(`${baseURL}/customers-v2/list/sms/customers`, { params })
            .then((res) => {
                return res.data.data
            })
            .catch((error) => {
                console.error('Error fetching sms customer list', error)
                throw error
            })
    }

    static async disableCustomerById(userId) {
        return axios
            .post(`${baseURL}/customer/${userId}/disable`)
            .then((res) => {
                return res
            })
            .catch((error) => {
                console.error('Error disable customer', error)
                throw error
            })
    }

    static async enableCustomerById(userId) {
        return axios
            .post(`${baseURL}/customer/${userId}/enable`)
            .then((res) => {
                return res
            })
            .catch((error) => {
                console.error('Error enable customer', error)
                throw error
            })
    }

    static async deleteCustomerById(userId) {
        return axios
            .post(`${baseURL}/customer/${userId}/delete`)
            .then((res) => {
                return res
            })
            .catch((error) => {
                console.error('Error delete customer', error)
                throw error
            })
    }
}
